import { useContext } from 'react';
import { Link } from 'react-router-dom';

import { CurrencyContext } from 'app/components/commons/Currency/CurrencyContext/CurrencyContext';
import { PictureComponent } from 'app/components/commons/PictureComponent/PictureComponent';
import { ProfilIcon } from 'app/components/commons/icons/DefaultProfile';
import type { BookingDetails } from 'app/typings/adminBookings/bookings';
import { format as formatDate } from 'app/utils/dayjs';

type Props = {
  bookingDetails: BookingDetails;
};

export const User = ({ bookingDetails }: Props) => {
  const {
    customerAdvanced,
    staycations,
    giftCards,
    bookingSummary: { customer },
  } = bookingDetails;
  const { firstName, lastName, gender, id: customerId } = customer;

  const { currencyFormatter } = useContext(CurrencyContext);

  const getUserName = () => {
    if (!firstName || !lastName) {
      return `#${customerId}`;
    }

    return gender === undefined || gender === 'Other'
      ? `${firstName} ${lastName}`
      : `${gender} ${firstName} ${lastName}`;
  };

  const amount =
    staycations.reduce((a, b) => a + b, 0) +
    giftCards.reduce((a, b) => a + b, 0);

  const myStaycations = `${staycations.length} booking${
    staycations.length > 1 ? 's' : ''
  } • 
        ${giftCards.length} card${giftCards.length > 1 ? 's' : ''} •
        ${currencyFormatter(amount)}`;

  return (
    <div className="bloc">
      <div className="title">User</div>
      <div className="user-content">
        {customerAdvanced && customerAdvanced.avatarPath ? (
          <PictureComponent
            className="avatar"
            style={{ borderRadius: '50%' }}
            pictureId={customerAdvanced.avatarPath}
          />
        ) : (
          <ProfilIcon />
        )}
        <div className="details">
          <div className="name">
            <Link
              className="link"
              to={`/users/${customerId}/edit`}
              target="_blank"
            >
              {getUserName()}
            </Link>
          </div>
          {customerAdvanced && customerAdvanced.birthDate && (
            <div className="birth-date">
              {formatDate(new Date(customerAdvanced.birthDate), 'DD/MM/YYYY ')}
            </div>
          )}
          <div className="staycations">{myStaycations}</div>
        </div>
      </div>
    </div>
  );
};
